import React from 'react'
import { Box } from 'grommet'
import GiftedAvatar from './GiftedAvatar'
import { isSameUser, isSameDay } from './utils'

const Avatar = ({
  renderAvatarOnTop = false,
  position = 'left',
  currentMessage = { user: null },
  nextMessage = {},
  previousMessage,
  avatarContainerStyle = {},
  imageStyle = {},
  renderAvatar,
  onPressAvatar,
  ...props
}) => {
  const renderAvatarElement = () => {
    if (renderAvatar) {
      const avatarProps = {
        renderAvatarOnTop,
        position,
        currentMessage,
        nextMessage,
        previousMessage,
        avatarContainerStyle,
        imageStyle,
        renderAvatar,
        onPressAvatar,
        ...props
      }
      return renderAvatar(avatarProps)
    }
    return (
      <GiftedAvatar
        avatarStyle={imageStyle[position]}
        user={currentMessage.user}
        onPress={() => onPressAvatar && onPressAvatar(currentMessage.user)}
      />
    )
  }

  const messageToCompare = renderAvatarOnTop ? previousMessage : nextMessage

  if (renderAvatar === null) {
    return null
  }

  if (
    isSameUser(currentMessage, messageToCompare) &&
    isSameDay(currentMessage, messageToCompare)
  ) {
    return (
      <Box style={avatarContainerStyle[position]}>
        <GiftedAvatar avatarStyle={imageStyle[position]} />
      </Box>
    )
  }

  return (
    <Box style={avatarContainerStyle[position]}>{renderAvatarElement()}</Box>
  )
}

export default Avatar
